/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { OfficeInfo } from '@gh/supplier-shared';

@Component({
  selector: 'gh-supplier-office-info',
  templateUrl: 'supplier-office-info.component.html',
  styleUrls: ['supplier-office-info.component.scss'],
})
export class SupplierOfficeInfoComponent {
  @Input() office: OfficeInfo;
}
